import { FleekError } from './FleekError';

export type FolderNameContainsReservedWordErrorOptions = {
  name: string;
};

export class FolderNameContainsReservedWordError extends FleekError<FolderNameContainsReservedWordErrorOptions> {
  public name = 'FolderNameContainsReservedWorkError';

  toString = () => `Folder name ${this.data.name} is reserved word and you cannot use it.`;
}
